export class CleanLogModel {
  id!: number;

  userId!: string;

  days!: number;

  totalRemoved!: number;

  updateDate!: string;

  insertDate!: string;
}
